<template>
	<button type="button" class="wood-sample" :class="{'active' : isActive}" role="radio" :aria-checked="isActive ? 'true' : 'false'" :aria-label="woodName" @click.prevent="onSelect">
		<div class="bb-wood-type">
			<div class="uk-flex uk-flex-middle">
                <div class="img-container" :style="imgStyle" aria-hidden="true"></div>
                <p>{{ woodName }}</p>
            </div>
		</div>
	</button>
</template>

<script>
	export default {
		props : {
			wood : Object,
			selected : Object
		},
		name : "wood-type",
		components: {},
		methods : {
			onSelect(){
				this.$emit('select',this.wood);
			}
		},
		computed : {
			isActive() {
				if(this.selected == null ) return false;
				return this.wood.id == this.selected.id;
			},
			woodImage(){
				return (this.wood.image == undefined)? "" : this.wood.image.webPath;
			},
			imgStyle(){
				return `background-image: url(${this.woodImage}/200);`;
			},
			woodName(){
				return (this.wood.name == undefined)? "" : this.wood.name;
			}
		}
	}
</script>